exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/core-js/modules/_wks-ext.js
// module id = 301
// module chunks = 20